import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class GroupRoleTemplateNameCollisionError extends CodedError {
  static get errorName() {
    return errorCodes.groupRoleTemplateNameCollision.code;
  }

  constructor(
    message: string = errorCodes.groupRoleTemplateNameCollision.message
  ) {
    super(message);
    this.code = errorCodes.groupRoleTemplateNameCollision.code;
    this.message = `${message} ${errorCodes.groupRoleTemplateNameCollision.code}`;
    this.name = errorCodes.groupRoleTemplateNameCollision.name;
  }
}
